export const tenantTypeOptions = ['Internal', 'External', 'Technical', 'Pre-GA'];

export const SHARED_TENANT_USER_NAMES = [
  'Manny',
  'Anders',
  'Scott',
  'Corey',
  'Mike',
  'Prisha',
  'Jeff',
  'Max',
  'Jenn',
  'Beth',
  'Cassie',
  'Mikal',
  'LucyO',
  'Alex',
  'Mia',
  'Seth',
  'itsmuser',
  'CSMAdmin',
  'Liam',
  'helixservice',
];

/** Per-user reset configuration — extend with backend-driven rules when available. */
export const sharedTenantResetUserConfig = SHARED_TENANT_USER_NAMES.map((name) => ({
  name,
  resetAllowed: true,
}));

/** @deprecated Use SHARED_TENANT_USER_NAMES — kept for existing imports. */
export const sharedTenantUsers = SHARED_TENANT_USER_NAMES;

export const availabilityStatusOptions = ['Available', 'Maintenance', 'Under Upgrade'];

export const bookingStatusOptions = ['Available', 'Booked', 'Pending Cleanup'];

export const faultStatusOptions = ['Healthy', 'Faulted'];

export const regionOptions = ['NA', 'EMEA', 'APJ', 'LATAM', 'Global'];

export const environmentOptions = ['Production', 'Staging', 'Sandbox', 'Pre-GA'];

export const mockTenantData = [
  {
    id: 'tenant-internal-16',
    tenantNumber: 16,
    tenantType: 'Internal',
    tenantUrl: 'https://helixdemoash2643-itom-demo.onbmc.com',
    itsmUrl: 'https://helixdemoash2643-demo-restapi.onbmc.com',
    username: 'Liam',
    region: 'NA',
    environment: 'Production',
    labels: ['V26.2 DI', 'Sales Ready'],
    availabilityStatus: 'Available',
    bookingStatus: 'Available',
    faultStatus: 'Healthy',
    cleanupStatus: 'Completed',
    upgradeStatus: 'Current',
    currentBooking: null,
    integrations: {
      jira: 'https://jira.example.com/projects/INT16',
      catchpoint: 'https://catchpoint.example.com/internal-16',
      dynatrace: 'internal16.live.dynatrace.example.com',
      chatOps: '#tc-internal-tenants',
    },
    isActive: true,
    createdAt: '2026-01-12T10:30:00Z',
    updatedAt: '2026-07-29T08:40:00Z',
  },
  {
    id: 'tenant-internal-17',
    tenantNumber: 17,
    tenantType: 'Internal',
    tenantUrl: 'https://helixdemoash2648-itom-demo.onbmc.com',
    itsmUrl: 'https://helixdemoash2648-demo-restapi.onbmc.com',
    username: 'Liam',
    region: 'EMEA',
    environment: 'Production',
    labels: ['V26.2 DI'],
    availabilityStatus: 'Available',
    bookingStatus: 'Booked',
    faultStatus: 'Healthy',
    cleanupStatus: 'Not Required',
    upgradeStatus: 'Current',
    currentBooking: {
      bookedUserName: 'Ahmed Emam',
      bookedUserEmail: 'ahmed.emam@example.com',
      bookingType: 'Customer Demo',
      bookingStartTime: '2026-08-03T04:30:00Z',
      bookingEndTime: '2026-08-03T14:47:00Z',
      customerName: 'Northstar Bank',
      sfdcNumber: 'SFDC-48192',
    },
    integrations: {
      jira: 'https://jira.example.com/projects/INT17',
      catchpoint: 'https://catchpoint.example.com/internal-17',
      dynatrace: 'internal17.live.dynatrace.example.com',
      chatOps: '#tc-leadership-demos',
    },
    isActive: true,
    createdAt: '2026-02-01T09:00:00Z',
    updatedAt: '2026-07-30T07:45:00Z',
  },
  {
    id: 'tenant-internal-18',
    tenantNumber: 18,
    tenantType: 'Internal',
    tenantUrl: 'https://internal18.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/internal-18',
    username: 'demo_admin',
    region: 'APJ',
    environment: 'Staging',
    labels: ['training', 'bootcamp'],
    availabilityStatus: 'Maintenance',
    bookingStatus: 'Available',
    faultStatus: 'Healthy',
    cleanupStatus: 'Completed',
    upgradeStatus: 'Current',
    currentBooking: null,
    integrations: {
      jira: 'https://jira.example.com/projects/INT18',
      catchpoint: 'https://catchpoint.example.com/internal-18',
      dynatrace: 'internal18.stage.dynatrace.example.com',
      chatOps: '#tc-training',
    },
    isActive: true,
    createdAt: '2026-03-03T13:10:00Z',
    updatedAt: '2026-07-25T11:00:00Z',
  },
  {
    id: 'tenant-internal-19',
    tenantNumber: 19,
    tenantType: 'Internal',
    tenantUrl: 'https://helixdemoash2654-itom-demo.onbmc.com',
    itsmUrl: 'https://helixdemoash2654-demo-restapi.onbmc.com',
    username: 'hannah_admin',
    region: 'NA',
    environment: 'Sandbox',
    labels: [],
    availabilityStatus: 'Available',
    bookingStatus: 'Pending Cleanup',
    faultStatus: 'Healthy',
    cleanupStatus: 'Pending',
    upgradeStatus: 'Current',
    currentBooking: null,
    integrations: {
      jira: 'https://jira.example.com/projects/INT19',
      catchpoint: 'https://catchpoint.example.com/internal-19',
      dynatrace: 'internal19.sandbox.dynatrace.example.com',
      chatOps: '#tc-tenant-ops',
    },
    isActive: true,
    createdAt: '2026-03-19T14:00:00Z',
    updatedAt: '2026-07-28T15:20:00Z',
  },
  {
    id: 'tenant-external-21',
    tenantNumber: 21,
    tenantType: 'External',
    tenantUrl: 'https://external21.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/external-21',
    username: 'partner_admin',
    region: 'EMEA',
    environment: 'Production',
    labels: ['partner', 'pae'],
    availabilityStatus: 'Available',
    bookingStatus: 'Booked',
    faultStatus: 'Healthy',
    cleanupStatus: 'Not Required',
    upgradeStatus: 'Current',
    currentBooking: {
      bookedUserName: 'Jon Bell',
      bookedUserEmail: 'jon.bell@example.com',
      bookingType: 'Partner Workshop',
      bookingStartTime: '2026-07-31T09:00:00Z',
      bookingEndTime: '2026-08-01T09:00:00Z',
      customerName: 'Acme Systems',
      sfdcNumber: 'SFDC-49210',
    },
    integrations: {
      jira: 'https://jira.example.com/projects/EXT21',
      catchpoint: 'https://catchpoint.example.com/external-21',
      dynatrace: 'external21.live.dynatrace.example.com',
      chatOps: '#tc-partner-tenants',
    },
    isActive: true,
    createdAt: '2026-01-21T08:00:00Z',
    updatedAt: '2026-07-29T13:25:00Z',
  },
  {
    id: 'tenant-external-22',
    tenantNumber: 22,
    tenantType: 'External',
    tenantUrl: 'https://external22.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/external-22',
    username: 'partner_admin',
    region: 'LATAM',
    environment: 'Production',
    labels: ['spanish', 'partner'],
    availabilityStatus: 'Available',
    bookingStatus: 'Booked',
    faultStatus: 'Faulted',
    cleanupStatus: 'Pending',
    upgradeStatus: 'Current',
    currentBooking: {
      bookedUserName: 'Elena Garcia',
      bookedUserEmail: 'elena.garcia@example.com',
      bookingType: 'Customer Demo',
      bookingStartTime: '2026-07-28T11:00:00Z',
      bookingEndTime: '2026-07-29T11:00:00Z',
      customerName: 'Banco Cordillera',
      sfdcNumber: 'SFDC-47715',
    },
    integrations: {
      jira: 'https://jira.example.com/projects/EXT22',
      catchpoint: 'https://catchpoint.example.com/external-22',
      dynatrace: 'external22.live.dynatrace.example.com',
      chatOps: '#tc-latam-demos',
    },
    isActive: true,
    createdAt: '2026-02-11T12:00:00Z',
    updatedAt: '2026-07-30T03:10:00Z',
  },
  {
    id: 'tenant-external-23',
    tenantNumber: 23,
    tenantType: 'External',
    tenantUrl: 'https://external23.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/external-23',
    username: 'partner_admin',
    region: 'NA',
    environment: 'Sandbox',
    labels: ['roadshow'],
    availabilityStatus: 'Under Upgrade',
    bookingStatus: 'Available',
    faultStatus: 'Healthy',
    cleanupStatus: 'Completed',
    upgradeStatus: 'Running',
    currentBooking: null,
    integrations: {
      jira: 'https://jira.example.com/projects/EXT23',
      catchpoint: 'https://catchpoint.example.com/external-23',
      dynatrace: 'external23.sandbox.dynatrace.example.com',
      chatOps: '#tc-roadshow',
    },
    isActive: true,
    createdAt: '2026-03-15T09:45:00Z',
    updatedAt: '2026-07-30T01:40:00Z',
  },
  {
    id: 'tenant-external-24',
    tenantNumber: 24,
    tenantType: 'External',
    tenantUrl: 'https://external24.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/external-24',
    username: 'partner_admin',
    region: 'APJ',
    environment: 'Production',
    labels: ['partner'],
    availabilityStatus: 'Available',
    bookingStatus: 'Available',
    faultStatus: 'Healthy',
    cleanupStatus: 'Completed',
    upgradeStatus: 'Current',
    currentBooking: null,
    integrations: {
      jira: 'https://jira.example.com/projects/EXT24',
      catchpoint: 'https://catchpoint.example.com/external-24',
      dynatrace: 'external24.live.dynatrace.example.com',
      chatOps: '#tc-partner-tenants',
    },
    isActive: false,
    createdAt: '2026-04-09T11:20:00Z',
    updatedAt: '2026-07-15T10:15:00Z',
  },
  {
    id: 'tenant-technical-31',
    tenantNumber: 31,
    tenantType: 'Technical',
    tenantUrl: 'https://technical31.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/technical-31',
    username: 'tech_admin',
    region: 'Global',
    environment: 'Staging',
    labels: ['technical', 'sandbox'],
    availabilityStatus: 'Available',
    bookingStatus: 'Available',
    faultStatus: 'Healthy',
    cleanupStatus: 'Completed',
    upgradeStatus: 'Current',
    currentBooking: null,
    integrations: {
      jira: 'https://jira.example.com/projects/TECH31',
      catchpoint: 'https://catchpoint.example.com/technical-31',
      dynatrace: 'technical31.stage.dynatrace.example.com',
      chatOps: '#tc-technical-tenants',
    },
    isActive: true,
    createdAt: '2026-01-09T08:30:00Z',
    updatedAt: '2026-07-26T16:20:00Z',
  },
  {
    id: 'tenant-technical-32',
    tenantNumber: 32,
    tenantType: 'Technical',
    tenantUrl: 'https://technical32.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/technical-32',
    username: 'tech_admin',
    region: 'NA',
    environment: 'Sandbox',
    labels: ['api', 'integration'],
    availabilityStatus: 'Maintenance',
    bookingStatus: 'Available',
    faultStatus: 'Faulted',
    cleanupStatus: 'Failed',
    upgradeStatus: 'Current',
    currentBooking: null,
    integrations: {
      jira: 'https://jira.example.com/projects/TECH32',
      catchpoint: 'https://catchpoint.example.com/technical-32',
      dynatrace: 'technical32.sandbox.dynatrace.example.com',
      chatOps: '#tc-api-lab',
    },
    isActive: true,
    createdAt: '2026-02-06T15:40:00Z',
    updatedAt: '2026-07-30T06:10:00Z',
  },
  {
    id: 'tenant-technical-33',
    tenantNumber: 33,
    tenantType: 'Technical',
    tenantUrl: 'https://technical33.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/technical-33',
    username: 'tech_admin',
    region: 'EMEA',
    environment: 'Production',
    labels: [],
    availabilityStatus: 'Available',
    bookingStatus: 'Booked',
    faultStatus: 'Healthy',
    cleanupStatus: 'Not Required',
    upgradeStatus: 'Current',
    currentBooking: {
      bookedUserName: 'Priya Menon',
      bookedUserEmail: 'priya.menon@example.com',
      bookingType: 'Architecture Lab',
      bookingStartTime: '2026-07-30T05:30:00Z',
      bookingEndTime: '2026-08-02T05:30:00Z',
      customerName: 'Helios Retail',
      sfdcNumber: 'SFDC-48803',
    },
    integrations: {
      jira: 'https://jira.example.com/projects/TECH33',
      catchpoint: 'https://catchpoint.example.com/technical-33',
      dynatrace: 'technical33.live.dynatrace.example.com',
      chatOps: '#tc-architecture-labs',
    },
    isActive: true,
    createdAt: '2026-04-16T07:15:00Z',
    updatedAt: '2026-07-29T18:00:00Z',
  },
  {
    id: 'tenant-technical-34',
    tenantNumber: 34,
    tenantType: 'Technical',
    tenantUrl: 'https://technical34.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/technical-34',
    username: 'tech_admin',
    region: 'APJ',
    environment: 'Staging',
    labels: ['upgrade-validation'],
    availabilityStatus: 'Under Upgrade',
    bookingStatus: 'Available',
    faultStatus: 'Healthy',
    cleanupStatus: 'Completed',
    upgradeStatus: 'Scheduled',
    currentBooking: null,
    integrations: {
      jira: 'https://jira.example.com/projects/TECH34',
      catchpoint: 'https://catchpoint.example.com/technical-34',
      dynatrace: 'technical34.stage.dynatrace.example.com',
      chatOps: '#tc-upgrade-validation',
    },
    isActive: false,
    createdAt: '2026-05-02T10:25:00Z',
    updatedAt: '2026-07-20T08:35:00Z',
  },
  {
    id: 'tenant-prega-41',
    tenantNumber: 41,
    tenantType: 'Pre-GA',
    tenantUrl: 'https://prega41.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/prega-41',
    username: 'prega_admin',
    region: 'NA',
    environment: 'Pre-GA',
    labels: ['early-access', 'aiops'],
    availabilityStatus: 'Available',
    bookingStatus: 'Booked',
    faultStatus: 'Healthy',
    cleanupStatus: 'Not Required',
    upgradeStatus: 'Current',
    currentBooking: {
      bookedUserName: 'Chris Nolan',
      bookedUserEmail: 'chris.nolan@example.com',
      bookingType: 'Pre-GA Preview',
      bookingStartTime: '2026-08-03T14:00:00Z',
      bookingEndTime: '2026-08-04T14:00:00Z',
      customerName: 'Evergreen Energy',
      sfdcNumber: 'SFDC-49982',
    },
    integrations: {
      jira: 'https://jira.example.com/projects/PREGA41',
      catchpoint: 'https://catchpoint.example.com/prega-41',
      dynatrace: 'prega41.preview.dynatrace.example.com',
      chatOps: '#tc-prega-preview',
    },
    isActive: true,
    createdAt: '2026-06-01T09:10:00Z',
    updatedAt: '2026-07-27T12:05:00Z',
  },
  {
    id: 'tenant-prega-42',
    tenantNumber: 42,
    tenantType: 'Pre-GA',
    tenantUrl: 'https://prega42.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/prega-42',
    username: 'prega_admin',
    region: 'EMEA',
    environment: 'Pre-GA',
    labels: ['early-access', 'customer-zero'],
    availabilityStatus: 'Maintenance',
    bookingStatus: 'Available',
    faultStatus: 'Faulted',
    cleanupStatus: 'Pending',
    upgradeStatus: 'Current',
    currentBooking: null,
    integrations: {
      jira: 'https://jira.example.com/projects/PREGA42',
      catchpoint: 'https://catchpoint.example.com/prega-42',
      dynatrace: 'prega42.preview.dynatrace.example.com',
      chatOps: '#tc-prega-preview',
    },
    isActive: true,
    createdAt: '2026-06-11T12:40:00Z',
    updatedAt: '2026-07-30T09:05:00Z',
  },
  {
    id: 'tenant-prega-43',
    tenantNumber: 43,
    tenantType: 'Pre-GA',
    tenantUrl: 'https://prega43.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/prega-43',
    username: 'prega_admin',
    region: 'APJ',
    environment: 'Pre-GA',
    labels: ['ml', 'demo-safe'],
    availabilityStatus: 'Available',
    bookingStatus: 'Available',
    faultStatus: 'Healthy',
    cleanupStatus: 'Completed',
    upgradeStatus: 'Current',
    currentBooking: null,
    integrations: {
      jira: 'https://jira.example.com/projects/PREGA43',
      catchpoint: 'https://catchpoint.example.com/prega-43',
      dynatrace: 'prega43.preview.dynatrace.example.com',
      chatOps: '#tc-prega-preview',
    },
    isActive: true,
    createdAt: '2026-06-20T14:20:00Z',
    updatedAt: '2026-07-24T09:30:00Z',
  },
  {
    id: 'tenant-prega-44',
    tenantNumber: 44,
    tenantType: 'Pre-GA',
    tenantUrl: 'https://prega44.techcentral.example.com',
    itsmUrl: 'https://itsm.example.com/prega-44',
    username: 'prega_admin',
    region: 'Global',
    environment: 'Pre-GA',
    labels: [],
    availabilityStatus: 'Available',
    bookingStatus: 'Pending Cleanup',
    faultStatus: 'Healthy',
    cleanupStatus: 'Pending',
    upgradeStatus: 'Current',
    currentBooking: null,
    integrations: {
      jira: 'https://jira.example.com/projects/PREGA44',
      catchpoint: 'https://catchpoint.example.com/prega-44',
      dynatrace: 'prega44.preview.dynatrace.example.com',
      chatOps: '#tc-prega-preview',
    },
    isActive: false,
    createdAt: '2026-06-28T09:00:00Z',
    updatedAt: '2026-07-18T07:45:00Z',
  },
];
